import { Box, Flex, Image, Text, VStack, Divider, Badge } from '@chakra-ui/react';
import styles from '../Orders.module.css'; 
import { Receipt } from './Receipt';
import { formatTimestamp } from '../Utils/utils';
import { FcOk } from "react-icons/fc";
import { BsXCircleFill } from "react-icons/bs";
import { PocoOrderType } from '../Types/types';

export const Order = ({ pocoOrder }: { pocoOrder: PocoOrderType }) => {
    const transactionDateTime = formatTimestamp(pocoOrder.createdAt).toString();
    return (
            <Box className={styles['order-container']}>
                <Flex flexDir="row" margin={{ base: "10px 5px", md: "29px 24px" }}>
                    <Box width="120px" height="79px" borderRadius="6px" display="flex" justifyContent="center" alignItems="center" >
                        <Image
                            src="/Images/pococare_order_logo.png"
                            alt="Poco care Image"
                            width="100%"
                            height="100%"
                            objectFit="cover"
                        />
                    </Box>
                    <VStack paddingLeft="16px" gap={{ base: "4px", sm:"4px", md: "12px" }} align="start" flex="1">
                        <Flex alignItems="center" flexWrap="wrap">
                            <Text className={styles['order-text']} marginRight="12px">
                                {pocoOrder.orderFor.charAt(0).toUpperCase() + pocoOrder.orderFor.slice(1)}
                            </Text>
                            {   pocoOrder.paymentStatus === "paid" ?
                                (<>
                                    <FcOk />
                                    <Text className={styles['order-text']} marginLeft="8px" color="#29A972">Successful</Text>
                                </>) : pocoOrder.paymentStatus === "pending" ?
                                (<>
                                    <Badge colorScheme="yellow">Pending</Badge>
                                </>) :
                                (<>
                                    <BsXCircleFill color='red' />
                                    <Text className={styles['order-text']} marginLeft="8px" color="#EA1515">Failed</Text>
                                </>)
                            }
                        </Flex>
                        <Text className={styles['order-transaction']}>Transaction ID : #{pocoOrder.transactionId}</Text>
                        <Text className={`${styles['transaction-date-time']} ${styles['t-d-t-sm']}`}>Time : {transactionDateTime}</Text>
                        <Text className={styles['order-total']}>Total Amount : ₹{typeof pocoOrder.amount === 'number' ? pocoOrder.amount.toFixed(2) : parseFloat(pocoOrder.amount).toFixed(2)}</Text>
                        <Text className={styles['order-transaction']}>Payment Provider : {pocoOrder.paymentProvider.charAt(0).toUpperCase() + pocoOrder.paymentProvider.slice(1)}</Text>
                    </VStack>
                </Flex>
                <div className={`${styles['transaction-date-time']} ${styles['t-d-t-lg']}`}>
                    <p>{transactionDateTime}</p>
                </div>
                
                {pocoOrder.items && pocoOrder.items.length > 0 && (
                    <Box margin={{ base: "10px 5px", md: "0 24px 20px 24px" }}>
                        <Divider marginBottom="12px" />
                        <Text className={styles['order-text']} marginBottom="8px">Order Items:</Text>
                        {pocoOrder.items.map((item, index) => (
                            <Flex key={index} justifyContent="space-between" alignItems="center" padding="8px 0">
                                <Box>
                                    <Text className={styles['order-transaction']}>{item.itemName}</Text>
                                    <Text className={styles['order-transaction']} fontSize="12px">Quantity: {item.quantity}</Text>
                                </Box>
                                
                            </Flex>
                        ))}
                    </Box>
                )}
                
                {pocoOrder.paymentStatus === "paid" && <Receipt pocoOrderId={ pocoOrder._id } />}
            </Box>
    )
}
